<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="formGroup">
    
    <div class="clearfix">
      <!-------------------------------->
      <!-- Search Criteria Indicators:-->
      <!-------------------------------->
      
      <div class="col col-12 m-b-5" *ngFor="let key of controlKeys">
        <app-element-slide-toggle [label]="controls[key]"
                                  [formControlName]="key"
                                  [disabled]="formGroup.get(key).disabled">
        </app-element-slide-toggle>
      </div>
    </div>
  
  </form>
  <mat-dialog-actions align="center" class="dialog-button-container">
    <div class="flex justify-center">
      <button class="dialog-button" mat-raised-button color="warn" (click)="onClickCancelDialog()">Cancel</button>
      <button class="dialog-button" mat-raised-button color="primary" (click)="onClickSave()">Okay</button>
    </div>
  </mat-dialog-actions>
</div>
